import styled from 'styled-components';
import { EnhancedSectionTitle } from '../../styles/sharedComponents';

export const HumanismSection = styled.section<{ $isVisible?: boolean }>`
  padding: 120px 0;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #0a0a0a 0%, #050505 100%);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  }
`;

export const HumanismGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
    text-align: center;
  }
`;

export const HumanismContent = styled.div`
  position: relative;
  z-index: 2;
`;

export const HumanismTitle = styled(EnhancedSectionTitle)`
  text-align: left;
  margin-bottom: 24px;

  @media (max-width: 1024px) {
    text-align: center;
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

export const HumanismDescription = styled.p`
  font-size: 1.125rem;
  color: #a1a1aa;
  line-height: 1.8;
  margin-bottom: 32px;

  strong {
    color: #fafafa;
    font-weight: 600;
  }
`;

export const NotebookContainer = styled.div`
  position: relative;
  perspective: 2000px;
  transform-style: preserve-3d;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

export const NotebookFrame = styled.div`
  position: relative;
  width: 100%;
  padding-top: 62.5%; /* Aspect ratio 16:10 */
  background: #1a1a1a;
  border-radius: 24px;
  box-shadow:
    0 50px 100px -20px rgba(0, 0, 0, 0.5),
    0 30px 60px -30px rgba(0, 0, 0, 0.6),
    inset 0 0 0 2px rgba(255, 255, 255, 0.1);
  transition: transform 0.5s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: -16px;
    left: 2%;
    width: 96%;
    height: 16px;
    background: #2a2a2a;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.5);
    transform: translateZ(-1px);
  }
`;

export const NotebookScreen = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  bottom: 12px;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
`;

export const DualImageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  gap: 2px;
  background: #0a0a0a;

  @keyframes fadeInMagnifier {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
